
import { nextTick, reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import NText from '@/uikit/text/NText.vue';
import { dataModule } from '@/store/data';

@Options({
  name: 'TableItemCameraGroups',
  components: { NText }
})
export default class TableItemCameraGroups extends Vue {
  @Prop({ type: Array, required: true })
  readonly modelValue!: number[];

  get content() {
    if (Array.isArray(this.modelValue)) {
      return this.modelValue
        .map((id) => {
          const item = dataModule.cameraGroupsModule.items.find((v) => v.id === id);
          return item?.name || '';
        })
        .filter((v) => !!v)
        .join(', ');
    }
    return '-';
  }
}
